"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnownContextTagKeys = exports.KnownSeverityLevel = exports.KnownDataPointType = void 0;
/** Known values of {@link DataPointType} that the service accepts. */
var KnownDataPointType;
(function (KnownDataPointType) {
    /** Measurement */
    KnownDataPointType["Measurement"] = "Measurement";
    /** Aggregation */
    KnownDataPointType["Aggregation"] = "Aggregation";
})(KnownDataPointType || (exports.KnownDataPointType = KnownDataPointType = {}));
/** Known values of {@link SeverityLevel} that the service accepts. */
var KnownSeverityLevel;
(function (KnownSeverityLevel) {
    /** Verbose */
    KnownSeverityLevel["Verbose"] = "Verbose";
    /** Information */
    KnownSeverityLevel["Information"] = "Information";
    /** Warning */
    KnownSeverityLevel["Warning"] = "Warning";
    /** Error */
    KnownSeverityLevel["Error"] = "Error";
    /** Critical */
    KnownSeverityLevel["Critical"] = "Critical";
})(KnownSeverityLevel || (exports.KnownSeverityLevel = KnownSeverityLevel = {}));
/** Known values of {@link ContextTagKeys} that the service accepts. */
var KnownContextTagKeys;
(function (KnownContextTagKeys) {
    /** AiApplicationVer */
    KnownContextTagKeys["AiApplicationVer"] = "ai.application.ver";
    /** AiDeviceId */
    KnownContextTagKeys["AiDeviceId"] = "ai.device.id";
    /** AiDeviceLocale */
    KnownContextTagKeys["AiDeviceLocale"] = "ai.device.locale";
    /** AiDeviceModel */
    KnownContextTagKeys["AiDeviceModel"] = "ai.device.model";
    /** AiDeviceOemName */
    KnownContextTagKeys["AiDeviceOemName"] = "ai.device.oemName";
    /** AiDeviceOsVersion */
    KnownContextTagKeys["AiDeviceOsVersion"] = "ai.device.osVersion";
    /** AiDeviceType */
    KnownContextTagKeys["AiDeviceType"] = "ai.device.type";
    /** AiLocationIp */
    KnownContextTagKeys["AiLocationIp"] = "ai.location.ip";
    /** AiLocationCountry */
    KnownContextTagKeys["AiLocationCountry"] = "ai.location.country";
    /** AiLocationProvince */
    KnownContextTagKeys["AiLocationProvince"] = "ai.location.province";
    /** AiLocationCity */
    KnownContextTagKeys["AiLocationCity"] = "ai.location.city";
    /** AiOperationId */
    KnownContextTagKeys["AiOperationId"] = "ai.operation.id";
    /** AiOperationName */
    KnownContextTagKeys["AiOperationName"] = "ai.operation.name";
    /** AiOperationParentId */
    KnownContextTagKeys["AiOperationParentId"] = "ai.operation.parentId";
    /** AiOperationSyntheticSource */
    KnownContextTagKeys["AiOperationSyntheticSource"] = "ai.operation.syntheticSource";
    /** AiOperationCorrelationVector */
    KnownContextTagKeys["AiOperationCorrelationVector"] = "ai.operation.correlationVector";
    /** AiSessionId */
    KnownContextTagKeys["AiSessionId"] = "ai.session.id";
    /** AiSessionIsFirst */
    KnownContextTagKeys["AiSessionIsFirst"] = "ai.session.isFirst";
    /** AiUserAccountId */
    KnownContextTagKeys["AiUserAccountId"] = "ai.user.accountId";
    /** AiUserId */
    KnownContextTagKeys["AiUserId"] = "ai.user.id";
    /** AiUserAuthUserId */
    KnownContextTagKeys["AiUserAuthUserId"] = "ai.user.authUserId";
    /** AiCloudRole */
    KnownContextTagKeys["AiCloudRole"] = "ai.cloud.role";
    /** AiCloudRoleVer */
    KnownContextTagKeys["AiCloudRoleVer"] = "ai.cloud.roleVer";
    /** AiCloudRoleInstance */
    KnownContextTagKeys["AiCloudRoleInstance"] = "ai.cloud.roleInstance";
    /** AiCloudLocation */
    KnownContextTagKeys["AiCloudLocation"] = "ai.cloud.location";
    /** AiInternalSdkVersion */
    KnownContextTagKeys["AiInternalSdkVersion"] = "ai.internal.sdkVersion";
    /** AiInternalAgentVersion */
    KnownContextTagKeys["AiInternalAgentVersion"] = "ai.internal.agentVersion";
    /** AiInternalNodeName */
    KnownContextTagKeys["AiInternalNodeName"] = "ai.internal.nodeName";
})(KnownContextTagKeys || (exports.KnownContextTagKeys = KnownContextTagKeys = {}));
//# sourceMappingURL=index.js.map